__turbopack_context__.v({
  "HeaderMainContainer": "template-module-scss-module__OXE8Wa__HeaderMainContainer",
  "MainContainer": "template-module-scss-module__OXE8Wa__MainContainer",
  "MainContainerLikes": "template-module-scss-module__OXE8Wa__MainContainerLikes",
  "TabsWrapper": "template-module-scss-module__OXE8Wa__TabsWrapper",
  "Viewport": "template-module-scss-module__OXE8Wa__Viewport",
  "ViewportContainer": "template-module-scss-module__OXE8Wa__ViewportContainer",
  "ViewportContainerMobile": "template-module-scss-module__OXE8Wa__ViewportContainerMobile",
  "ViewportContainerWide": "template-module-scss-module__OXE8Wa__ViewportContainerWide",
  "ViewportContainerWrapper": "template-module-scss-module__OXE8Wa__ViewportContainerWrapper",
});
